<template>
    <div class="invoice">
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" :disabled="loading" size="mini">
                    <el-form-item label="开票申请号" label-width="100px">
                        <el-input v-model="searchForm.applicationNo" placeholder="账单编号" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="订单编号" label-width="80px">
                        <el-input v-model="searchForm.orderNo" placeholder="订单编号" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="客户订单编号" label-width="100px">
                        <el-input v-model="searchForm.customerOrderId" placeholder="客户订单编号" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="发票申请时间">
                        <el-date-picker size="mini" v-model="searchForm.timeDate" type="daterange" range-separator="至"
                                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                                        :picker-options="pickerOptions" clearable>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="开票状态" label-width="70px">
                        <el-select v-model="searchForm.status" placeholder="状态" size="mini" clearable style="width: 150px">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="申请中" value="0"></el-option>
                            <el-option label="已开票" value="1"></el-option>
                            <el-option label="驳回" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="结算状态" label-width="70px">
                        <el-select v-model="searchForm.settlStatus" placeholder="状态" size="mini" clearable style="width: 150px">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未结算" value="0"></el-option>
                            <el-option label="已结算" value="1"></el-option>
                            <el-option label="结算中" value="2"></el-option>
                            <el-option label="结算异常" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="doSearch" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table
                    stripe
                    :data="tableData"
                    v-loading="loading"
                    style="width: 100%"
                    :height="tableConfig.height"
                    :span-method="spanMethod"
                    :cell-style="cellStyle"
                    size="mini"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column type="selection" width="55" fixed/>
                    <el-table-column prop="applicationNo" label="开票申请号" width="130" />
                    <el-table-column prop="orderNo" label="订单编号" width="150" />
                    <el-table-column prop="currentBatch" label="当前批次号" width="80"/>
                    <el-table-column prop="currentOrderNum" label="当前批次子订单总数" width="80"/>
                    <el-table-column label="当前批次不含税总金额" align="center" width="300">
                        <el-table-column prop="currentBatchNakedAmount" align="center" label="京采" width="150" />
                        <el-table-column prop="platformCurrentBatchNakedAmount" align="center" label="平台" width="150" />
                    </el-table-column>
                    <el-table-column label="当前批次含税总金额" align="center" width="300">
                        <el-table-column prop="currentBatchAmount" align="center" label="京采" width="150" />
                        <el-table-column prop="platformCurrentBatchAmount" align="center" label="平台" width="150" />
                    </el-table-column>
                    <el-table-column prop="totalBatch" label="总批次数" width="80"/>
                    <el-table-column prop="totalOrderNum" label="总批次的子订单总数" width="80"/>
                    <el-table-column label="总批次的不含税总金额" align="center" width="300">
                        <el-table-column prop="totalBatchNakedAmount" align="center" label="京采" width="150" />
                        <el-table-column prop="platformTotalBatchNakedAmount" align="center" label="平台" width="150" />
                    </el-table-column>
                    <el-table-column label="总批次的含税总金额" align="center" width="300">
                        <el-table-column prop="totalBatchAmount" align="center" label="京采" width="150" />
                        <el-table-column prop="platformTotalBatchAmount" align="center" label="平台" width="150" />
                    </el-table-column>
                    <el-table-column prop="status" label="开票状态" width="80">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status == 0" size="mini">申请中</el-tag>
                            <el-tag type="success" v-if="scope.row.status == 1" size="mini">已开票</el-tag>
                            <el-tooltip v-if="scope.row.status == 2" :content="scope.row.reason || '驳回'" placement="top" effect="dark">
                                <el-tag type="warning" size="mini">驳回</el-tag>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="结算状态" width="80">
                        <template slot-scope="scope">
                            <el-tag type="info" v-if="scope.row.settlStatus == 0" size="mini">未结算</el-tag>
                            <el-tag type="success" v-if="scope.row.settlStatus == 1" size="mini">已结算</el-tag>
                            <el-tag v-if="scope.row.settlStatus == 2" size="mini">结算中</el-tag>
                            <el-tag type="warning" v-if="scope.row.settlStatus == 3" size="mini">结算异常</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="发票申请时间" min-width="200"/>
                    <el-table-column prop="opt" label="操作" width="250" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="handleToOrder(scope.row)">订单</el-button>
                            <!-- <el-button type="text" size="mini" @click="handleShowInvoice(scope.row)">发票</el-button>
                            <el-button type="text" size="mini" @click="handleShowConsignee(scope.row)">收票人</el-button> -->
                            <el-button type="text" size="mini" @click="handleShowConfirm(scope.row)">确认开票信息</el-button>
                            <el-button type="text" size="mini" @click="handleShowinvoiceForm(scope.row)">发票回执</el-button>
                            <!-- <el-button :disabled="scope.row.settlStatus != 0" type="text" size="mini" @click="handleSettlement(scope.row)">结算</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination background layout="sizes, prev, pager, next" v-if="total>0" :total="total"
                                    :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :current-page="currentPage" @size-change="handleSizeChange"
                                    @current-change="onPageChange" @prev-click="onPageChange" @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="申请开票信息" :visible.sync="invoiceDialogVisible"  :close-on-click-modal="false">
            <div class="invoiceForm">
                <el-row class="invoiceRow">
                    <el-col style="text-align: right" :span="2">发票类型 :</el-col>
                    <el-col style="padding-left: 16px" :span="6">{{selectedInvoice.invoiceType == 1 ? '增值税普通发票' : '增值税专用发票'}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">发票抬头 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedInvoice.invoiceTitle}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">发票内容 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedInvoice.content == 1 ? '明细' : '大类'}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">纳税人识别号 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedInvoice.itins}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">开户银行 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedInvoice.bank}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">银行账户 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedInvoice.account}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">注册地址 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedInvoice.address}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">注册电话 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedInvoice.telephone}}</el-col>
                </el-row>
            </div>
        </el-dialog>
        <el-dialog title="开票收票人信息" :visible.sync="consigneeDialogVisible"  :close-on-click-modal="false">
            <div class="invoiceForm">
                <el-row class="invoiceRow">
                    <el-col style="text-align: right" :span="2">收票人姓名 :</el-col>
                    <el-col style="padding-left: 16px" :span="6">{{selectedConsignee.name}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">收票人手机号 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedConsignee.mobile}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">省级 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedConsignee.province}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">市级 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedConsignee.city}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">县区 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedConsignee.county}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">乡镇 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedConsignee.town}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">详细地址 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedConsignee.address}}</el-col>
                </el-row>
            </div>
        </el-dialog>
        <el-dialog title="确认开票信息" :visible.sync="confirmInvoiceDialogVisible" :close-on-click-modal="false" width="80%">
            <div class="confirm-invoice-content">
                <!-- 发票信息 -->
                <el-card shadow="never" style="margin-bottom: 20px;">
                    <div slot="header">
                        <span>申请开票信息</span>
                    </div>
                    <div class="invoiceForm">
                        <el-row class="invoiceRow">
                            <el-col :span="12">
                                <div class="info-item">
                                    <span class="info-label">发票类型：</span>
                                    <span class="info-value">{{confirmInvoiceData.invoiceInfo.invoiceType == 1 ? '增值税普通发票' : '增值税专用发票'}}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="info-item">
                                    <span class="info-label">发票内容：</span>
                                    <span class="info-value">{{confirmInvoiceData.invoiceInfo.content == 1 ? '明细' : '大类'}}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="invoiceRow">
                            <el-col :span="12">
                                <div class="info-item">
                                    <span class="info-label">发票抬头：</span>
                                    <span class="info-value">{{confirmInvoiceData.invoiceInfo.invoiceTitle}}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="info-item">
                                    <span class="info-label">纳税人识别号：</span>
                                    <span class="info-value">{{confirmInvoiceData.invoiceInfo.itins}}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="invoiceRow">
                            <el-col :span="12">
                                <div class="info-item">
                                    <span class="info-label">开户银行：</span>
                                    <span class="info-value">{{confirmInvoiceData.invoiceInfo.bank}}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="info-item">
                                    <span class="info-label">银行账户：</span>
                                    <span class="info-value">{{confirmInvoiceData.invoiceInfo.account}}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="invoiceRow">
                            <el-col :span="12">
                                <div class="info-item">
                                    <span class="info-label">注册地址：</span>
                                    <span class="info-value">{{confirmInvoiceData.invoiceInfo.address}}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="info-item">
                                    <span class="info-label">注册电话：</span>
                                    <span class="info-value">{{confirmInvoiceData.invoiceInfo.telephone}}</span>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <!-- 收票人信息 -->
                <el-card shadow="never" style="margin-bottom: 20px;">
                    <div slot="header">
                        <span>开票收票人信息</span>
                    </div>
                    <div class="invoiceForm">
                        <el-row class="invoiceRow">
                            <el-col :span="12">
                                <div class="info-item">
                                    <span class="info-label">收票人姓名：</span>
                                    <span class="info-value">{{confirmInvoiceData.receiverInfo.name}}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="info-item">
                                    <span class="info-label">收票人手机号：</span>
                                    <span class="info-value">{{confirmInvoiceData.receiverInfo.mobile}}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="invoiceRow">
                            <el-col :span="24">
                                <div class="info-item">
                                    <span class="info-label">收票地址：</span>
                                    <span class="info-value">{{getReceiverAddress()}}</span>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <!-- 订单信息表格 -->
                <el-card shadow="never" style="margin-bottom: 20px;">
                    <div slot="header">
                        <span>订单信息</span>
                    </div>
                    <el-table :data="orderTableData" border stripe size="mini" style="width: 100%" :summary-method="getSummaries" show-summary>
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="orderNo" label="订单号" min-width="150"></el-table-column>
                        <el-table-column prop="companyName" label="客户公司" min-width="200"></el-table-column>
                        <el-table-column prop="total" label="订单金额" width="120" align="right">
                            <template slot-scope="scope">
                                {{formatAmount(scope.row.total)}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="invoiceAmount" label="发票请求金额" width="140" align="right">
                            <template slot-scope="scope">
                                {{formatAmount(scope.row.invoiceAmount)}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="errorMessages" label="信息" min-width="200" align="left">
                            <template slot-scope="scope">
                                <div v-if="scope.row.errorMessages && scope.row.errorMessages.length > 0" class="error-messages">
                                    <div v-for="(msg, index) in scope.row.errorMessages" :key="index" class="error-message">
                                        {{msg}}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="confirmInvoiceDialogVisible = false">关闭</el-button>
                <el-button v-if="currentInvoiceStatus == 0 && currentSettlStatus == 0" type="warning" @click="handleReject">驳回</el-button>
                <el-button v-if="currentInvoiceStatus == 0 && currentSettlStatus == 0" type="primary" @click="handleGenerateSettlement">生成结算单</el-button>
            </div>
        </el-dialog>
        <!-- 驳回理由弹窗 -->
        <el-dialog title="驳回理由" :visible.sync="rejectDialogVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="rejectFormRef" :model="rejectForm" :rules="rejectRules" label-width="100px">
                <el-form-item label="驳回理由" prop="reason">
                    <el-input
                        type="textarea"
                        :rows="4"
                        v-model="rejectForm.reason"
                        placeholder="请输入驳回理由"
                        maxlength="500"
                        show-word-limit>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="rejectDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleConfirmReject">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="开票回执" :visible.sync="editInvReceiptVisible"  :close-on-click-modal="false" width="90%">
            <el-form ref="frm" :model="{receiptFormBase, receiptForms}" label-width="120px">
                <!-- 共享信息 -->
                <el-card shadow="never" style="margin-bottom: 20px;">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="开票申请号：" label-width="130px">
                                <div>{{receiptFormBase.applicationNo}}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="发票类型：" label-width="140px">
                                <div>{{receiptFormBase.invoiceType == 1 ? '增值税普通发票' : '增值税专用发票'}}</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="发票抬头：" label-width="140px">
                                <div>{{receiptFormBase.invoiceTitle}}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="发票总金额：" label-width="140px">
                                <div>{{receiptFormBase.invoiceAmount}}</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="发票未税金额：" label-width="140px">
                                <div>{{receiptFormBase.invoiceNakedAmount}}</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="发票材质：" prop="invoiceMaterial" label-width="140px">
                                <el-select :disabled="receiptFormBase.status == 1" v-model="receiptFormBase.invoiceMaterial" placeholder="请选择" size="mini" clearable style="width: 150px">
                                    <el-option label="电子票" value="1"></el-option>
                                    <el-option label="纸质发票" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="发票张数" prop="invoiceNum" label-width="140px">
                                <el-input-number :min="1" :step="1" v-model="receiptFormBase.invoiceNum" placeholder="请填写发票张数" :disabled="receiptFormBase.status == 1" @change="handleInvoiceNumChange"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-card>
                <!-- 发票列表 -->
                <div v-for="(form, index) in receiptForms" :key="index" style="margin-bottom: 20px;">
                    <el-card shadow="never">
                        <div slot="header">
                            <span>发票 {{ index + 1 }}</span>
                        </div>
                        <el-form :ref="`receiptForm${index}`" :model="form" :rules="rules" label-width="120px">
<!--                            <el-row>-->
<!--                                <el-col :span="24">-->
<!--                                    <el-form-item label="电子票下载地址：" :prop="`receiptForms.${index}.fileUrl`" label-width="140px">-->
<!--                                        <el-upload-->
<!--                                            class="avatar-uploader"-->
<!--                                            :ref="`upload${index}`"-->
<!--                                            action="/api/admin/uploadInvoice"-->
<!--                                            name="file"-->

<!--                                            :limit="1"-->
<!--                                            :show-file-list="true"-->
<!--                                            :file-list="form.fileList || []"-->
<!--                                            :on-exceed="onExceed"-->

<!--                                            :on-preview="handlePreview"-->
<!--                                            :on-success="(res, file) => handleSuccess(res, file, index)"-->
<!--                                            :on-remove="() => handleRemove(index)">-->
<!--                                            <el-button size="small" type="primary">点击上传</el-button>-->
<!--                                            <div slot="tip" class="el-upload__tip">只能上传pdf文件，且不超过10MB</div>-->
<!--                                        </el-upload>-->
<!--                                    </el-form-item>-->
<!--                                </el-col>-->
<!--                            </el-row>-->
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="电子票下载地址：" :prop="`receiptForms.${index}.fileUrl`" label-width="140px">
                                        <el-upload
                                                class="avatar-uploader"
                                                :ref="`upload${index}`"
                                                action="/api/admin/uploadXmlInvoice"
                                                name="file"
                                                :limit="1"
                                                :show-file-list="true"
                                                :file-list="form.fileList || []"
                                                :on-exceed="onExceed"
                                                accept=".zip"
                                                :before-upload="(file) => beforeUpload(file, index)"
                                                :on-preview="handlePreview"
                                                :on-success="(res, file) => handleSuccess(res, file, index)"
                                                :on-remove="() => handleRemove(index)">
                                            <el-button size="small" type="primary">点击上传</el-button>
                                            <div slot="tip" class="el-upload__tip">只能上传zip文件，且不超过10MB</div>
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="请填写发票代码：" :prop="`receiptForms.${index}.invoiceCode`" label-width="140px">
                                        <el-input placeholder="请填写发票代码" v-model="form.invoiceCode" :disabled="receiptFormBase.status == 1" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="发票号码：" :prop="`receiptForms.${index}.invoiceId`" label-width="140px">
                                        <el-input placeholder="请填写发票号码" v-model="form.invoiceId" :disabled="receiptFormBase.status == 1" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="开票内容：" :prop="`receiptForms.${index}.invoiceContent`" label-width="140px">
                                        <el-input placeholder="请填写开票内容" v-model="form.invoiceContent" type="textarea" :rows="4" :disabled="receiptFormBase.status == 1" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="开票机构名称：" :prop="`receiptForms.${index}.billOrg`" label-width="140px">
                                        <el-input placeholder="请填写开票机构名称" v-model="form.billOrg" :disabled="receiptFormBase.status == 1" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="纳税人识别号：" :prop="`receiptForms.${index}.taxpayer`" label-width="140px">
                                        <el-input placeholder="请填写纳税人识别号" v-model="form.taxpayer" :disabled="receiptFormBase.status == 1" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <!-- 当发票张数>1时，显示订单列表 -->
                            <el-row v-if="receiptFormBase.invoiceNum > 1 && receiptFormBase.status == 0">
                                <el-col :span="24">
                                    <el-form-item label="选择订单（可多选）：" label-width="140px">
                                        <el-table
                                            :ref="`orderTable${index}`"
                                            :data="receiptOrderList"
                                            @selection-change="(selection) => handleReceiptOrderSelectionChange(selection, index)"
                                            :row-key="row => row.id"
                                            border
                                            style="width: 100%">
                                            <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
                                            <el-table-column prop="orderNo" label="订单号" width="180"></el-table-column>
                                            <el-table-column prop="companyName" label="客户公司"></el-table-column>
                                            <el-table-column prop="total" label="订单金额" width="120">
                                                <template slot-scope="scope">
                                                    {{ formatAmount(scope.row.total) }}
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editInvReceiptVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit" :disabled="receiptFormBase.status == 1">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
const HEIGHT_OFFSET = 118;
export default {
    name: "Invoice",
    data() {
        let validateInvoice = (rule, value, callback) => {
            // 在验证函数中，this指向组件实例
            // 需要从rule中获取字段路径来找到对应的表单索引
            if(rule.fullField && rule.fullField.includes('receiptForms')) {
                // 如果是数组验证，从rule.fullField中提取索引
                const match = rule.fullField.match(/receiptForms\.(\d+)\.taxpayer/);
                if(match) {
                    const index = parseInt(match[1]);
                    const form = this.receiptForms[index];
                    if(this.receiptFormBase.invoiceType == 2 && value === ""){
                        callback(new Error('请填写纳税人识别号'))
                        return;
                    }
                }
            } else if(this.receiptFormBase.invoiceType == 2 && value === ""){
                callback(new Error('请填写纳税人识别号'))
                return;
            }
            callback()
        }
        let validateFileUrl = (rule, value, callback) => {
            // 发票材质现在是共享的，检查 receiptFormBase.invoiceMaterial
            if(this.receiptFormBase.invoiceMaterial == 1 && value === ""){
                callback(new Error('请填写电子票下载地址'))
                return;
            }
            callback()
        }
        return {
            searchForm: {
                applicationNo: "",
                orderNo: "",
                customerOrderId: "",
                status: "",
                settlStatus: "",
                timeDate: "",
            },
            tableConfig: {
                height: 0,
            },
            searchFormStash: {},
            selectData: [],
            loading: false,
            total: 0,
            pageSize: 10,
            pageSizes: [10, 20, 50, 100],
            currentPage: 1,
            tableData: [],
            // 合并规则对象，key 为起始行索引，value 为合并的行数
            mergeObj: {},
            // 注意：mergeCol 已不再使用，合并逻辑现在基于 columnIndex 判断（0=选择框，1=applicationNo）

            invoiceDialogVisible: false,
            selectedInvoice: {},

            consigneeDialogVisible: false,
            selectedConsignee: {},

            confirmInvoiceDialogVisible: false,
            confirmInvoiceData: {
                invoiceInfo: {},
                receiverInfo: {}
            },
            currentInvoiceStatus: 0, // 当前发票的开票状态
            currentSettlStatus: 0, // 当前发票的结算状态
            currentApplicationNo: '', // 当前发票的申请号
            orderTableData: [], // 订单信息表格数据（占位）

            rejectDialogVisible: false,
            rejectForm: {
                applicationNo: '',
                reason: ''
            },
            rejectRules: {
                reason: [{ required: true, message: '请填写驳回理由', trigger: 'blur' }]
            },

            editInvReceiptVisible: false,
            receiptForms: [], // 多张发票的数组
            receiptFormBase: { // 基础表单数据（用于共享字段）
                applicationNo: '',
                invoiceType: '',
                invoiceNakedAmount: '',
                invoiceAmount: '',
                invoiceTitle: '',
                invoiceMaterial: '1', // 发票材质
                invoiceNum: 1, // 发票张数
                status: '',
            },
            receiptOrderList: [], // 开票回执弹窗中的订单列表（从接口获取的原始数据）
            rules: {
                invoiceId: [{ required: true, message: '请填写发票号码', trigger: 'blur' }],
                invoiceCode: [{ required: true, message: '请填写发票代码', trigger: 'blur' }],
                invoiceContent: [{ required: true, message: '请填写开票内容', trigger: 'blur' }],
                invoiceMaterial: [{ required: true, message: '请选择发票材质', trigger: 'blur' }],
                billOrg: [{ required: true, message: '请填写开票机构名称', trigger: 'blur' }],
                taxpayer: [{ validator: validateInvoice, trigger: 'blur'}],
                fileUrl: [{ validator: validateFileUrl, trigger: 'blur'}],

            },
        }

    },
    created() {
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.onSearch();
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    methods: {
        onSearch() {
            this.selectData = [];
            let cond = { ...this.searchForm };
            if (!this.searchForm.status) {
                cond['status'] = undefined;
            }
            if (this.searchForm.timeDate != "" && this.searchForm.timeDate != null) {
                cond["startTime"] = this.searchForm.timeDate[0];
                cond["endTime"] = this.searchForm.timeDate[1];
            }
            this.searchFormStash = {...cond};
            this.loading = true;
            let _this = this
            this.$axios.post("/admin/jcy/settlement/invoicelist", {
                cond: cond,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                    _this.getSpanArr(_this.tableData);
                }
            }).catch(function () {
                this.loading = false;
            });
        },
        doSearch() {
            this.currentPage=1;
            this.onSearch();
        },
        onSubmit() {
            let _this = this;
            // 验证共享字段
            if (!this.receiptFormBase.invoiceMaterial) {
                this.$message.error('请选择发票材质');
                return;
            }
            
            // 手动验证所有表单字段
            let hasError = false;
            
            for (let i = 0; i < this.receiptForms.length; i++) {
                const form = this.receiptForms[i];
                // 验证必填字段
                if (!form.invoiceCode) {
                    this.$message.error(`第${i + 1}张发票：请填写发票代码`);
                    hasError = true;
                    break;
                }
                if (!form.invoiceId) {
                    this.$message.error(`第${i + 1}张发票：请填写发票号码`);
                    hasError = true;
                    break;
                }
                if (!form.invoiceContent) {
                    this.$message.error(`第${i + 1}张发票：请填写开票内容`);
                    hasError = true;
                    break;
                }
                if (!form.billOrg) {
                    this.$message.error(`第${i + 1}张发票：请填写开票机构名称`);
                    hasError = true;
                    break;
                }
                // 验证电子票需要文件
                if (this.receiptFormBase.invoiceMaterial == 1 && !form.fileUrl) {
                    this.$message.error(`第${i + 1}张发票：电子票需要上传文件`);
                    hasError = true;
                    break;
                }
                // 验证专用发票需要纳税人识别号
                if (this.receiptFormBase.invoiceType == 2 && !form.taxpayer) {
                    this.$message.error(`第${i + 1}张发票：专用发票需要填写纳税人识别号`);
                    hasError = true;
                    break;
                }
                // 当发票张数>1且status=0时，验证是否选择了订单
                if (this.receiptFormBase.invoiceNum > 1 && this.receiptFormBase.status == 0) {
                    if (!form.selectedOrderIds || form.selectedOrderIds.length === 0) {
                        this.$message.error(`第${i + 1}张发票：请至少选择一个订单`);
                        hasError = true;
                        break;
                    }
                }
            }
            
            if (hasError) {
                return;
            }
            
            // 构建提交数据
            const submitData = {
                applicationNo: this.receiptFormBase.applicationNo,
                invoiceMaterial: this.receiptFormBase.invoiceMaterial,
                invoiceNum: this.receiptFormBase.invoiceNum,
                receipts: this.receiptForms.map(form => {
                    const receipt = {
                        invoiceId: form.invoiceId,
                        invoiceCode: form.invoiceCode,
                        invoiceContent: form.invoiceContent,
                        billOrg: form.billOrg,
                        taxpayer: form.taxpayer,
                        fileUrl: form.fileUrl || ''
                    };
                    // 当发票张数>1且status=0时，添加选中的订单id数组
                    if (this.receiptFormBase.invoiceNum > 1 && this.receiptFormBase.status == 0) {
                        receipt.orderIds = form.selectedOrderIds || [];
                    }
                    return receipt;
                })
            };
            
            this.$axios.post("/admin/jcy/settlement/invReceipt", submitData)
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header && resp.header.status == 0) {
                        _this.$notify({
                            title: '成功',
                            message: '数据保存成功',
                            type: 'success'
                        });
                        _this.editInvReceiptVisible = false;
                        _this.resetReceiptForms();
                        _this.onSearch();
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg || resp.resultMsg || '保存失败'
                        });
                    }
                })
                .catch(function (error) {
                    _this.$notify.error({
                        title: '错误',
                        message: '保存失败'
                    });
                });
        },
        handleInvoiceNumChange(value) {
            // 根据发票张数生成相应数量的表单
            const currentLength = this.receiptForms.length;
            const targetLength = value || 1;
            
            if (targetLength > currentLength) {
                // 需要增加
                for (let i = currentLength; i < targetLength; i++) {
                    this.receiptForms.push({
                        invoiceId: '',
                        invoiceCode: '',
                        invoiceContent: '',
                        billOrg: '',
                        taxpayer: '',
                        fileUrl: '',
                        fileList: [],
                        selectedOrderIds: [] // 每张发票的选中订单id数组
                    });
                }
            } else if (targetLength < currentLength) {
                // 需要减少
                this.receiptForms = this.receiptForms.slice(0, targetLength);
            }
        },
        handleReceiptOrderSelectionChange(selection, index) {
            // 处理订单选择变化，更新对应发票的选中订单id数组
            if (this.receiptForms[index]) {
                this.receiptForms[index].selectedOrderIds = selection.map(order => order.id);
            }
        },
        resetReceiptForms() {
            this.receiptForms = [];
            this.receiptFormBase = {
                applicationNo: '',
                invoiceType: '',
                invoiceNakedAmount: '',
                invoiceAmount: '',
                invoiceTitle: '',
                invoiceMaterial: '1',
                invoiceNum: 1,
                status: '',
            };
            this.receiptOrderList = [];
        },
        pickerOptions: {
            disabledDate(time) {
                return time.getTime() > Date.now();
            },
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        handleToOrder(row) {
            this.$router.push({
                name: "jcyorder", query: {applicationNo:row.applicationNo}, params:{title:"订单列表"}
            });
        },
        handleShowInvoice(row) {
            this.selectedInvoice = JSON.parse(row.invoiceInfo);
            this.invoiceDialogVisible = true;
        },
        handleShowConsignee(row) {
            this.selectedConsignee = JSON.parse(row.receiverInfo);
            this.consigneeDialogVisible = true;
        },
        handleShowConfirm(row) {
            let _this = this;
            this.loading = true;
            this.$axios.get(`/admin/jcy/settlement/invoiceDetail/${row.applicationNo}`)
                .then(function (response) {
                    _this.loading = false;
                    let resp = response.data;
                    if (resp.header && resp.header.status == 0) {
                        // 解析发票信息（字符串化的 JSON）
                        try {
                            _this.confirmInvoiceData.invoiceInfo = resp.data.invoiceInfo 
                                ? (typeof resp.data.invoiceInfo === 'string' 
                                    ? JSON.parse(resp.data.invoiceInfo) 
                                    : resp.data.invoiceInfo)
                                : {};
                        } catch (e) {
                            console.error('解析发票信息失败:', e);
                            _this.confirmInvoiceData.invoiceInfo = {};
                        }
                        
                        // 解析收票人信息（字符串化的 JSON）
                        try {
                            _this.confirmInvoiceData.receiverInfo = resp.data.receiverInfo 
                                ? (typeof resp.data.receiverInfo === 'string' 
                                    ? JSON.parse(resp.data.receiverInfo) 
                                    : resp.data.receiverInfo)
                                : {};
                        } catch (e) {
                            console.error('解析收票人信息失败:', e);
                            _this.confirmInvoiceData.receiverInfo = {};
                        }
                        
                        // 处理订单信息
                        _this.processOrderData(resp.data);
                        
                        // 保存当前行的状态信息
                        _this.currentInvoiceStatus = resp.data.status != null ? resp.data.status : (row.status != null ? row.status : 0);
                        _this.currentSettlStatus = resp.data.settlStatus != null ? resp.data.settlStatus : (row.settlStatus != null ? row.settlStatus : 0);
                        _this.currentApplicationNo = row.applicationNo;
                        
                        // 设置驳回表单的申请号
                        _this.rejectForm.applicationNo = row.applicationNo;
                        _this.confirmInvoiceDialogVisible = true;
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg || '获取开票信息失败'
                        });
                    }
                })
                .catch(function (error) {
                    _this.loading = false;
                    _this.$notify.error({
                        title: '错误',
                        message: '获取开票信息失败'
                    });
                });
        },
        handleReject() {
            // 打开驳回理由弹窗
            this.rejectForm.reason = '';
            this.rejectDialogVisible = true;
        },
        handleConfirmReject() {
            let _this = this;
            this.$refs.rejectFormRef.validate(valid => {
                if (valid) {
                    _this.loading = true;
                    _this.$axios.post("/admin/jcy/settlement/rejectInvoice", {
                        applicationNo: _this.rejectForm.applicationNo,
                        reason: _this.rejectForm.reason
                    })
                        .then(function (response) {
                            _this.loading = false;
                            let resp = response.data;
                            if (resp.header && resp.header.status == 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '驳回成功',
                                    type: 'success'
                                });
                                _this.rejectDialogVisible = false;
                                _this.confirmInvoiceDialogVisible = false;
                                _this.onSearch(); // 刷新列表
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg || '驳回失败'
                                });
                            }
                        })
                        .catch(function (error) {
                            _this.loading = false;
                            _this.$notify.error({
                                title: '错误',
                                message: '驳回失败'
                            });
                        });
                }
            });
        },
        handleGenerateSettlement() {
            let _this = this;
            if (!this.currentApplicationNo) {
                this.$message.error('申请号不能为空');
                return;
            }
            
            this.$confirm('确认生成结算单？', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                _this.loading = true;
                _this.$axios.post(`/admin/jcy/settlement/createSettlement/${_this.currentApplicationNo}`)
                    .then(function (response) {
                        _this.loading = false;
                        let resp = response.data;
                        if (resp.header && resp.header.status == 0) {
                            _this.$notify({
                                title: '成功',
                                message: '生成结算单成功',
                                type: 'success'
                            });
                            _this.confirmInvoiceDialogVisible = false;
                            _this.onSearch(); // 刷新列表
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg || '生成结算单失败'
                            });
                        }
                    })
                    .catch(function (error) {
                        _this.loading = false;
                        _this.$notify.error({
                            title: '错误',
                            message: '生成结算单失败'
                        });
                    });
            }).catch(() => {
                // 用户取消操作
            });
        },
        getReceiverAddress() {
            const receiver = this.confirmInvoiceData.receiverInfo || {};
            const addressParts = [
                receiver.province,
                receiver.city,
                receiver.county,
                receiver.town,
                receiver.address
            ].filter(part => part && part.trim());
            return addressParts.join('');
        },
        processOrderData(data) {
            // 解析 orderInfos（字符串化的 JSON）
            let orderInfos = [];
            try {
                if (data.orderInfos) {
                    orderInfos = typeof data.orderInfos === 'string' 
                        ? JSON.parse(data.orderInfos) 
                        : data.orderInfos;
                }
            } catch (e) {
                console.error('解析订单信息失败:', e);
                orderInfos = [];
            }
            
            // 获取订单列表
            const orders = data.orders || [];
            
            // 获取发票抬头用于检查
            const invoiceTitle = this.confirmInvoiceData.invoiceInfo.invoiceTitle || '';
            
            // 构建订单表格数据
            this.orderTableData = orders.map(order => {
                // 通过 thirdOrderId 匹配 orderInfos
                const matchedOrderInfo = orderInfos.find(orderInfo => 
                    orderInfo.thirdOrderId === order.id
                );
                
                const invoiceAmount = matchedOrderInfo ? matchedOrderInfo.amount : 0;
                const orderTotal = order.total || 0;
                
                // 检查错误信息
                const errorMessages = [];
                
                // 检查1：订单金额与发票请求金额是否一致
                if (Math.abs(orderTotal - invoiceAmount) > 0.01) { // 允许0.01的误差
                    errorMessages.push('订单金额与开票金额不一致');
                }
                
                // 检查2：客户公司与发票抬头是否一致
                if (order.companyName && invoiceTitle && order.companyName !== invoiceTitle) {
                    errorMessages.push('下单公司与发票抬头不一致');
                }
                
                return {
                    orderNo: order.orderNo,
                    companyName: order.companyName,
                    total: orderTotal,
                    invoiceAmount: invoiceAmount,
                    errorMessages: errorMessages
                };
            });
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (column.property === 'total' || column.property === 'invoiceAmount') {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = this.formatAmount(values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0));
                    } else {
                        sums[index] = '0.00';
                    }
                } else {
                    sums[index] = '';
                }
            });
            return sums;
        },
        formatAmount(amount) {
            if (amount == null || amount === '') {
                return '0.00';
            }
            return Number(amount).toFixed(2);
        },
        handleShowinvoiceForm(row) {
            let _this = this;
            if(row.status == 0) {
                // 调用接口获取订单数据
                this.loading = true;
                this.$axios.get(`/admin/jcy/settlement/invoiceDetail/${row.applicationNo}`)
                    .then(function (response) {
                        _this.loading = false;
                        let resp = response.data;
                        if (resp.header && resp.header.status == 0) {
                            // 解析发票信息
                            let invoiceInfo = {};
                            try {
                                invoiceInfo = resp.data.invoiceInfo 
                                    ? (typeof resp.data.invoiceInfo === 'string' 
                                        ? JSON.parse(resp.data.invoiceInfo) 
                                        : resp.data.invoiceInfo)
                                    : {};
                            } catch (e) {
                                console.error('解析发票信息失败:', e);
                                invoiceInfo = JSON.parse(row.invoiceInfo);
                            }
                            
                            // 初始化基础表单数据
                            _this.receiptFormBase = {
                                applicationNo: row.applicationNo,
                                invoiceType: invoiceInfo.invoiceType,
                                invoiceNakedAmount: row.totalBatchNakedAmount,
                                invoiceAmount: row.totalBatchAmount,
                                invoiceTitle: invoiceInfo.invoiceTitle,
                                invoiceMaterial: '1',
                                invoiceNum: 1,
                                status: row.status
                            };
                            
                            // 初始化第一张发票表单
                            _this.receiptForms = [{
                                invoiceId: '',
                                invoiceCode: '',
                                invoiceContent: '',
                                billOrg: '',
                                taxpayer: '',
                                fileUrl: '',
                                fileList: [],
                                selectedOrderIds: [] // 每张发票的选中订单id数组
                            }];
                            
                            // 设置订单列表
                            _this.receiptOrderList = resp.data.orders || [];
                            
                            _this.editInvReceiptVisible = true;
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg || '获取订单信息失败'
                            });
                        }
                    })
                    .catch(function (error) {
                        _this.loading = false;
                        _this.$notify.error({
                            title: '错误',
                            message: '获取订单信息失败'
                        });
                    });
            }else{
                let _this = this;
                this.$axios.get(`/admin/jcy/settlement/getInvReceipt/${row.applicationNo}`).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        // 如果接口返回的是数组，直接使用；否则转换为数组
                        if (Array.isArray(resp.data.receipts)) {
                            _this.receiptForms = resp.data.receipts.map(receipt => ({
                                invoiceId: receipt.invoiceId || '',
                                invoiceCode: receipt.invoiceCode || '',
                                invoiceContent: receipt.invoiceContent || '',
                                billOrg: receipt.billOrg || '',
                                taxpayer: receipt.taxpayer || '',
                                fileUrl: receipt.fileUrl || '',
                                fileList: receipt.fileUrl ? [{ name: '发票文件', url: receipt.fileUrl }] : [],
                                selectedOrderIds: [] // 每张发票的选中订单id数组
                            }));
                            // 设置基础数据
                            _this.receiptFormBase = {
                                applicationNo: row.applicationNo,
                                invoiceType: resp.data.invoiceType || '',
                                invoiceNakedAmount: row.totalBatchNakedAmount || '',
                                invoiceAmount: row.totalBatchAmount || '',
                                invoiceTitle: resp.data.invoiceTitle || '',
                                invoiceMaterial: resp.data.invoiceMaterial || row.invoiceMaterial || '1',
                                invoiceNum: resp.data.invoiceNum || _this.receiptForms.length || 1,
                                status: row.status
                            };
                        } else if (resp.data) {
                            // 兼容旧格式，先设置基础数据
                            const invoiceNum = parseInt(resp.data.invoiceNum) || 1;
                            _this.receiptFormBase = {
                                applicationNo: row.applicationNo,
                                invoiceType: resp.data.invoiceType || '',
                                invoiceNakedAmount: row.totalBatchNakedAmount || '',
                                invoiceAmount: row.totalBatchAmount || '',
                                invoiceTitle: resp.data.invoiceTitle || '',
                                invoiceMaterial: resp.data.invoiceMaterial || row.invoiceMaterial || '1',
                                invoiceNum: invoiceNum,
                                status: row.status
                            };
                            // 根据发票张数生成表单数组（如果是旧格式，通常只有一张）
                            _this.receiptForms = [{
                                invoiceId: resp.data.invoiceId || '',
                                invoiceCode: resp.data.invoiceCode || '',
                                invoiceContent: resp.data.invoiceContent || '',
                                billOrg: resp.data.billOrg || '',
                                taxpayer: resp.data.taxpayer || '',
                                fileUrl: resp.data.fileUrl || '',
                                fileList: resp.data.fileUrl ? [{ name: '发票文件', url: resp.data.fileUrl }] : [],
                                selectedOrderIds: [] // 每张发票的选中订单id数组
                            }];
                            // 如果张数大于1，生成更多表单
                            if (invoiceNum > 1) {
                                for (let i = 1; i < invoiceNum; i++) {
                                    _this.receiptForms.push({
                                        invoiceId: '',
                                        invoiceCode: '',
                                        invoiceContent: '',
                                        billOrg: '',
                                        taxpayer: '',
                                        fileUrl: '',
                                        fileList: [],
                                        selectedOrderIds: [] // 每张发票的选中订单id数组
                                    });
                                }
                            }
                        } else {
                            // 全新数据，初始化默认值
                            _this.receiptFormBase = {
                                applicationNo: row.applicationNo,
                                invoiceType: '',
                                invoiceNakedAmount: row.totalBatchNakedAmount || '',
                                invoiceAmount: row.totalBatchAmount || '',
                                invoiceTitle: '',
                                invoiceMaterial: '1',
                                invoiceNum: 1,
                                status: row.status
                            };
                            // 初始化第一张发票表单
                            _this.receiptForms = [{
                                invoiceId: '',
                                invoiceCode: '',
                                invoiceContent: '',
                                billOrg: '',
                                taxpayer: '',
                                fileUrl: '',
                                fileList: [],
                                selectedOrderIds: [] // 每张发票的选中订单id数组
                            }];
                        }
                        _this.receiptOrderList = [];
                        _this.editInvReceiptVisible = true;
                    }
                });
            }
        },
        handleSettlement(row) {
            let _this = this;
            this.$confirm('确认打款信息完成后，发起结算。', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this.$axios.get(`/admin/jcy/settlement/settledNotice/${row.applicationNo}`).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        row.settlStatus == 2
                    }
                });
            })
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        cellStyle ({row, column, rowIndex, columnIndex}){
            if(column.property == "platformCurrentBatchNakedAmount" || column.property == "currentBatchNakedAmount") {
                if(row.platformCurrentBatchNakedAmount != row.currentBatchNakedAmount){
                    return "color: #e6a23c"
                }
            }

            if(column.property == "platformCurrentBatchAmount" || column.property == "currentBatchAmount") {
                if(row.platformCurrentBatchAmount != row.currentBatchAmount){
                    return "color: #e6a23c"
                }
            }

            if(column.property == "platformTotalBatchNakedAmount" || column.property == "totalBatchNakedAmount") {
                if(row.platformTotalBatchNakedAmount != row.totalBatchNakedAmount){
                    return "color: #e6a23c"
                }
            }

            if(column.property == "platformTotalBatchAmount" || column.property == "totalBatchAmount") {
                if(row.platformTotalBatchAmount != row.totalBatchAmount){
                    return "color: #e6a23c"
                }
            }
        },
        spanMethod ({ row, column, rowIndex, columnIndex }) {
            // 合并选择框列（columnIndex === 0）、applicationNo 列（columnIndex === 1）、操作列（prop === 'opt'）
            // 以及开票状态、结算状态、发票申请时间列
            const isSelectionColumn = columnIndex === 0;
            const isApplicationNoColumn = columnIndex === 1;
            const isOptColumn = column.property === 'opt';
            const isStatusColumn = column.label === '开票状态';
            const isSettlStatusColumn = column.label === '结算状态';
            const isCreateTimeColumn = column.property === 'createTime';
            
            if (isSelectionColumn || isApplicationNoColumn || isOptColumn || 
                isStatusColumn || isSettlStatusColumn || isCreateTimeColumn) {
                // 如果当前行是合并组的起始行
                if (this.mergeObj[rowIndex]) {
                    // 返回 [rowspan, colspan]，rowspan 为合并的行数，colspan 为 1
                    return [this.mergeObj[rowIndex], 1];
                } else {
                    // 如果当前行不是起始行，需要隐藏（返回 [0, 0]）
                    return [0, 0];
                }
            }
            // 其他列不合并
            return [1, 1];
        },
        getSpanArr (list) {
            // 清空之前的合并信息
            this.mergeObj = {};
            
            if (!list || list.length === 0) {
                return;
            }
            
            let startLine = [];
            let oldKey = "";
            
            // 找到不同 applicationNo 的起始行索引
            list.forEach((item, index) => {
                if (item.applicationNo != oldKey) {
                    startLine.push(index);
                    oldKey = item.applicationNo;
                }
            });
            
            // 计算每个合并组的行数
            startLine.forEach((startIndex, index) => {
                if (index < startLine.length - 1) {
                    // 当前组的行数 = 下一组的起始行 - 当前组的起始行
                    this.mergeObj[startIndex] = startLine[index + 1] - startIndex;
                } else {
                    // 最后一组的行数 = 总行数 - 起始行索引
                    this.mergeObj[startIndex] = list.length - startIndex;
                }
            });
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        },
        //文件上传成功的钩子函数
        handleSuccess(res, file, index) {
            // 兼容不同的响应格式：可能是 res 直接包含数据，或者 file.response 包含数据
            const responseData = (file && file.response && file.response.data) ? file.response.data : (res && res.data ? res.data : res);
            const responseHeader = (file && file.response && file.response.header) ? file.response.header : (res && res.header ? res.header : null);
            
            if (responseHeader && responseHeader.status == 0) {
                this.$message({
                    type: 'info',
                    message: '发票上传成功',
                    duration: 6000
                });
                const form = this.receiptForms[index];
                if (form) {
                    // 将返回的文件储存路径赋值fileUrl字段
                    form.fileUrl = responseData.url || responseData.fileUrl || '';
                    // 如果返回了其他字段，自动填充
                    if (responseData.invoiceId) {
                        form.invoiceId = responseData.invoiceId;
                    }
                    if (responseData.billOrg) {
                        form.billOrg = responseData.billOrg;
                    }
                    if (responseData.taxpayer) {
                        form.taxpayer = responseData.taxpayer;
                    }
                    if (responseData.invoiceContent) {
                        form.invoiceContent = responseData.invoiceContent;
                    }
                    // 更新文件列表用于显示
                    if (form.fileUrl) {
                        form.fileList = [{ name: file.name || '发票文件', url: form.fileUrl }];
                    }
                    // 强制触发响应式更新
                    this.$set(this.receiptForms, index, { ...form });
                }
            } else {
                this.$message({
                    type: 'info',
                    message: '发票上传失败',
                    duration: 6000
                });
            }
        },
        //删除文件之前的钩子函数
        handleRemove(index) {
            const form = this.receiptForms[index];
            if (form) {
                form.fileUrl = "";
                form.fileList = [];
            }
            this.$message({
                type: 'info',
                message: '已删除原有发票',
                duration: 6000
            });
        },
        //点击列表中已上传的文件事的钩子函数
        handlePreview() {
        },
        //上传的文件个数超出设定时触发的函数
        onExceed() {
        },
        //文件上传前的前的钩子函数
        //参数是上传的文件，若返回false，或返回Primary且被reject，则停止上传
        beforeUpload(file, index) {

            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isZip = file.type === 'application/x-zip-compressed';//application/pdf

            const isLt10M = file.size / 1024 / 1024 < 10;

            if (!isJPG && !isPNG && !isZip) {//JPG/PNG/Zip
                this.$message.error('上传文件必须是Zip 格式!');
            }
            if (!isLt10M) {
                this.$message.error('上传文件大小不能超过 10MB!');
            }
            return (isJPG || isPNG || isZip) && isLt10M;
        },
    }
}
</script>

<style>
.invoiceForm {
    padding-left: 20px;

    .invoiceRow {
        padding-bottom: 10px;
    }
    .invoiceTitleCol {
        text-align: right
    }
    .invoiceContentCol {
        padding-left: 16px
    }
}
.confirm-invoice-content {
    max-height: 70vh;
    overflow-y: auto;
}
.info-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
    .info-label {
        min-width: 120px;
        color: #606266;
        font-weight: 500;
    }
    .info-value {
        flex: 1;
        color: #303133;
    }
}
.error-messages {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1.5;
}
.error-message {
    margin-bottom: 2px;
}
</style>
